// extracted by mini-css-extract-plugin
export var header = "_vx-1";
export var maskBottom = "_vx-6";
export var maskMiddle = "_vx-7";
export var maskTop = "_vx-5";
export var root = "_vx-0";
export var scrollDownButton = "_vx-3";
export var scrollDownButtonHidden = "_vx-4";
export var viewport = "_vx-2";